import React, { useEffect, useState } from 'react';
import BlogService from '../../services/BlogServices';
import ImageService from '../../services/ImageService';
import { toast } from 'react-toastify';

const BlogImageUploader = ({ coverImageUrl, onChange, isEditable }) => {
  const [imageUrl, setImageUrl] = useState(coverImageUrl || ''); // Current image URL
  const [isUploading, setIsUploading] = useState(false); // Uploading state
  const MAX_IMAGE_SIZE = 200 * 1024; // Max size 200 KB

  useEffect(() => {
    if (coverImageUrl) {
      setImageUrl(coverImageUrl);
    }
  }, [coverImageUrl]);

  // Handle image upload or replace
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > MAX_IMAGE_SIZE) {
      toast.error('Image size exceeds 200 KB. Please upload a smaller image.');
      return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
      setIsUploading(true);

      // Remove the existing image before uploading a new one
      if (imageUrl) {
        const imageName = imageUrl.split('/').pop(); // Extract the image name from the URL
        await BlogService.removeImage(imageName);
      }

      // Upload the new image
      const imageName = await BlogService.uploadImage(formData); // Upload image and get the name
      const imagePath = ImageService.getImage + imageName; // Get the full image URL
      setImageUrl(imagePath);
      onChange(imagePath); // Notify parent about the change
      toast.success('Image uploaded successfully.');
    } catch (error) {
      toast.error(error.message || 'Failed to upload image.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="blog-image-uploader">
      <label className="form-label">Image Url</label>

      {/* Input for entering image URL directly */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Please Select Image"
          value={imageUrl}
          onChange={(e) => {
            setImageUrl(e.target.value);
            onChange(e.target.value); // Notify parent about the change
          }}
          readOnly
        />
      </div>

      {/* Upload/Replace Image */}
      <div className="d-flex align-items-center mb-3">
        <label className={`btn btn-${imageUrl ? 'primary' : 'secondary'} me-2`}>
          {imageUrl ? 'Choose Another' : 'Upload Image'}
          <input
            type="file"
            accept="image/*"
            className="d-none"
            onChange={handleImageUpload}
            disabled={!isEditable || isUploading} // Disable if not editable or uploading
          />
        </label>
        <span className="text-muted">Max size: 200 KB</span>
      </div>

      {/* Image Preview */}
      {imageUrl && (
        <div className="image-preview">
          <img
            src={imageUrl}
            alt="Cover"
            className="img-thumbnail mb-2"
            style={{ maxWidth: '250px', maxHeight: '250px' }}
          />
        </div>
      )}
    </div>
  );
};

export default BlogImageUploader;
